export enum FortnoxIntegrationType {
  Base = 'base',
  Salary = 'salary',
}
